<template>
    <div class="new-detail">
        <main class="detail">
            <div class="title">{{ data.newTitle }}</div>
            <div class="time">{{ data.issueDate | getTime }}</div>
            <div class="ident"><span></span><span></span></div>
            <!-- <div>
                <img :src="data.newPhone" alt="">
            </div> -->
            <div class="ql-editor" v-html="data.newContext"></div>
        </main>
    </div>
</template>
<style lang="less" scoped>
@activeColor: #E60012;

.new-detail {
    background: url(../assets/images/news/news_bg.png) right bottom no-repeat;
    padding-top: 40px;
}

.detail {
    width: 1200px;
    margin: 0 auto 51px;
    padding: 0;

    .ident {
        display: flex;
        width: 96px;
        margin: 0 auto;

        span {
            width: 48px;
            height: 4px;
            background-color: #353535;

            &:not(:last-child) {
                background-color: @activeColor;
            }

        }
    }

    .title {
        font-size: 24px;
        font-weight: 400;
        color: #393939;
    }

    .time {
        font-size: 16px;
        font-weight: 400;
        color: #7F7F7F;
        line-height: 23px;
        margin: 22px 0 30px;
    }

    img {
        width: 900px;
        height: 500px;
        margin: 40px 0 36px;
    }

}

@media screen and (max-width: 1360px) {
    .detail {
        width: 100%;

        /deep/ img {
            width: 100% !important;
        }
    }
}
</style>

<script>
import "@/assets/css/quill.snow.css"
export default {
    data() {
        return {
            id: this.$route.params.id,
            data: {}
        }
    },
    methods: {
        getData() {
            var that = this;
            ajax.call(this, {
                url: "/bloc/news/bloc/" + this.id,
                s(res) {
                    that.data = res.data;
                }
            });
        }
    },
    mounted() {
        this.getData();
    },
    filters: {
        getTime(value) {
            return value && value.slice(0, 10);
        }
    },
    watch: {
        "$root.language"() {
            // this.getData();
        },

    }
}
</script>